/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { initApolloClient } from "lib/withApollo";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import { PromotionContextProvider } from "src/contexts/promotion.context";
import { GET_PRODUCT } from "src/hooks/useProductBySlug";
import { ProductView } from "src/organisms/ProductView";

const ProductPage = (): JSX.Element => {
  const {
    query: { productSlug },
  } = useRouter();
  return (
    <PromotionContextProvider>
      <ProductView slug={productSlug as string} />
    </PromotionContextProvider>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params } = context;
  const slug = params?.productSlug as string;

  const apolloClient = initApolloClient({
    locale: process.env.LOCALE,
    storeKey: process.env.STORE_KEY,
  });

  try {
    const { data } = await apolloClient.query({
      query: GET_PRODUCT,
      variables: { slug },
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const product = data?.productBySlug;

    if (!product) {
      return { notFound: true };
    }

    return {
      props: {
        slug,
      },
    };
  } catch (error: any) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const message = error?.graphQLErrors?.[0]?.message;
    const isNotFound =
      message === "No product is found with the provided slug" ||
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (error?.graphQLErrors?.[0]?.extensions?.code === "NOT_FOUND" &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        error?.graphQLErrors?.[0]?.path?.[0] === "productBySlug");

    if (isNotFound) {
      return { notFound: true };
    }

    throw error;
  }
};

export default ProductPage;
